import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/type-camera.svg
 */
const IconTypeCamera: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M23.345 10.6a1.373 1.373 0 00-1.349-.046l-4.533 2.367a3.545 3.545 0 00-2.016-3.183 4.522 4.522 0 00.394-6.382 4.52 4.52 0 00-6.382-.394 4.436 4.436 0 00-.726.82 4.515 4.515 0 00-6.688-.779 4.52 4.52 0 00-.029 6.735A3.548 3.548 0 000 12.945v5.658a3.571 3.571 0 003.569 3.568h10.323a3.567 3.567 0 003.568-3.549l4.533 2.368A1.372 1.372 0 0024 19.774V11.77a1.363 1.363 0 00-.655-1.17zM12.43 3.5a2.88 2.88 0 012.832 3.4 2.877 2.877 0 01-5.706-.416v-.241a2.875 2.875 0 012.874-2.737v-.006zM9.053 9.369h-.645c.117-.127.224-.262.322-.403.099.143.207.28.323.41v-.007zM5.036 3.5a2.878 2.878 0 012.875 2.743v.24a2.878 2.878 0 11-2.875-2.983zm10.782 15.096a1.934 1.934 0 01-1.92 1.918H3.576a1.936 1.936 0 01-1.936-1.918v-5.66a1.933 1.933 0 011.936-1.935H13.9a1.936 1.936 0 011.92 1.935v5.66zm6.54.715l-4.891-2.552v-1.986l4.89-2.555v7.093z"
      fill="currentColor"
    />
  </svg>
);

export default IconTypeCamera;
